import { styled } from '@mui/material';

import { ChkHeader } from '../../ChkHeader/ChkHeader';
import type { ChkHeaderProps } from '../../ChkHeader/ChkHeader.types';

export const ModalHeader = ({
  componentEnd,
  componentStart,
  ...props
}: ChkHeaderProps) => {
  return (
    <StyledHeader
      componentStart={componentStart ?? <HeaderEmptyElement />}
      componentEnd={componentEnd ?? <HeaderEmptyElement />}
      {...props}
    />
  );
};

const StyledHeader = styled(ChkHeader)(({ theme }) => ({
  padding: theme.spacing(6, 6, 4, 6),
}));

export const HeaderEmptyElement = styled('div')(() => ({
  width: '2.6rem',
}));
